// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Gm-z","badgeLink":"Hm-z","category":"Im-z"};